import { ROUTER_PATH } from "@config/router";

/** 规范化 pathname 是否已在 onboarding 路由（避免重复 replace） */
export function isOnboardingRoute(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.ONBOARDING ||
    pathname.startsWith(`${ROUTER_PATH.ONBOARDING}/`)
  );
}

/** 规范化 pathname 是否已在 welcome 路由（避免重复 replace） */
export function isWelcomeRoute(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.WELCOME ||
    pathname.startsWith(`${ROUTER_PATH.WELCOME}/`)
  );
}

/** 规范化 pathname 是否已在 pricing 路由 */
export function isPricingRoute(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.MEMBER ||
    pathname.startsWith(`${ROUTER_PATH.MEMBER}/`)
  );
}

/** 规范化 pathname 是否已在 news 公开内容路由 */
export function isNewsRoute(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.NEWS || pathname.startsWith(`${ROUTER_PATH.NEWS}/`)
  );
}

/** welcome / pricing 沉浸式 onboarding 前置页，entry gate 同等处理 */
export function isWelcomeLikeRoute(pathname: string): boolean {
  return isWelcomeRoute(pathname) || isPricingRoute(pathname);
}

export { isAppAuxiliaryShellRoute } from "@utils/onboarding/appAuxiliaryShellRoute";

/** 独立登录 popup：不走 App 内 onboarding / welcome 跳转 */
export function isLoginPopupRoute(pathname: string): boolean {
  return pathname === "/login_popup" || pathname.startsWith("/login_popup/");
}

/** 独立登录页：页面内自带登录 UI，不叠全局强制登录弹窗 */
export function isLoginRoute(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.LOGIN ||
    pathname.startsWith(`${ROUTER_PATH.LOGIN}/`)
  );
}

/**
 * 会打扰 onboarding / welcome 流程的路由集合。
 * 这些路由下需要延后 push 弹窗 / 通知类 surface。
 */
export function isInterruptiveSurfaceRoute(pathname: string): boolean {
  return (
    isOnboardingRoute(pathname) ||
    isWelcomeRoute(pathname) ||
    isPricingRoute(pathname) ||
    isLoginPopupRoute(pathname) ||
    isLoginRoute(pathname)
  );
}
